/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState, useRef } from "react";
import { Layout, Row, Col, Typography, Form, Button, Input } from "antd";

import "./styleCss.scss";
import { JuradosService } from "../../../api/Jurados/api-jurados";
import { openNotification } from "../../../utils/Notifactions";
import DocumentosService from "../../../api/Documentos/api-documentos";
import getStorageUser from "../../../middlewares/GetStorageUser"
import apiDocumentos from "../../../api/Documentos/api-documentos";

const juriesServices = new JuradosService();

export default function EvaluacionProyectos(props: any) {

  const [user, setUser] = useState<any>({});


  const { Paragraph } = Typography;
  // @ts-ignore
  const { Content } = Layout;
  const [matchScreen, setMatchScreen] = useState<any>("");
  const [matchScreenSize, setMatchScreenSize] = useState<any>(1200);

  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const getUser = async () => {
    try {
      const user = getStorageUser();
      if (isMountedRef.current && user) {
        setUser(user);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (user?.documento) {
      setDocNumber(user.documento);
      getJury(user.documento);
    }
  }, [user]);

  useEffect(() => {
    getUser();

    let mobileQuery1024 = window.matchMedia("(max-width: 1024px)");
    let mobileQuery991 = window.matchMedia("(max-width: 991px)");
    let mobileQuery = window.matchMedia("(max-width: 768px)");

    if (
      mobileQuery1024.matches &&
      mobileQuery1024.media == "(max-width: 1024px)"
    ) {
      setMatchScreenSize(1024);
    }
    if (
      mobileQuery991.matches &&
      mobileQuery991.media == "(max-width: 991px)"
    ) {
      setMatchScreenSize(991);
    }
    if (
      mobileQuery.matches &&
      mobileQuery.media == "(max-width: 768px)"
    ) {
      setMatchScreenSize(768);
    }
    if (
      !mobileQuery1024.matches &&
      !mobileQuery991.matches &&
      !mobileQuery.matches
    ) {
      setMatchScreenSize(1200);
    }

    mediaQueryCheck(mobileQuery);
    mobileQuery.addEventListener("change", mediaQueryCheck);
    return () => {
      mobileQuery.removeEventListener("change", mediaQueryCheck);
    };
  }, [matchScreen]);
  function mediaQueryCheck(inputQuery: any) {
    if (inputQuery.matches) {
      setMatchScreen(true);
    } else {
      setMatchScreen(false);
    }
  }

  //===========================================================
  //                      SAVE SIGNATURE
  //===========================================================

  const [docNumber, setDocNumber] = useState<any>("");
  const [checked, setChecked] = useState<any>(false);
  const [fileName, setFileName] = useState<any>("");
  const [file, setFile] = useState<any>();
  const fileInputRef = useRef<any>();

  const getJury = async (docToSearch?: string) => {
    const doc = docToSearch || docNumber || user?.documento;
    if (!doc) {
      return;
    }

    try {
      const jury = await juriesServices.getJuryByDocNumber(doc);
      if (!isMountedRef.current) return;

      if (Array.isArray(jury) && jury.length > 0) {
        setChecked(true);
        if (
          jury[0]?.firma &&
          typeof jury[0].firma === "string" &&
          jury[0].firma !== "null" &&
          jury[0].firma !== "undefined" &&
          jury[0].firma.trim() !== ""
        ) {
          const data = await apiDocumentos.consultarArchivo(jury[0].firma);
          if (!isMountedRef.current) return;
          if (data?.data) {
            const reader = new FileReader();
            reader.readAsDataURL(data.data);
            reader.onloadend = function () {
              if (isMountedRef.current) {
                const base64String = reader.result;
                setFileName(base64String);
              }
            };
          }
        }
      }
    } catch (err) {
      console.error("Error al consultar jurado en EvaluacionProyectos:", err);
    }
  };

  const selectFile = (e: any) => {
    const { type } = e.target.files[0];

    if (type !== "image/png" && type !== "image/jpeg") {
      return openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos en formato .png y .jpg",
        placement: "bottomRight",
      });
    }

    const formData = new FormData();
    formData.append("archivo", e.target.files[0]);

    setFile(formData);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (docNumber === "" || !file) {
      return openNotification({
        titulo: "Atención",
        descripcion: "Complete todos los campos",
        placement: "bottomRight",
      });
    }

    if (!checked) {
      return openNotification({
        titulo: "Atención",
        descripcion: "Jurado no validado",
        placement: "bottomRight",
      });
    }

    try {
      const data = await DocumentosService.guardarArchivo(file);
      setFileName(data.data);
      const response = await juriesServices.saveSignature(docNumber, data.data);

      if (response) {
        setFile(null);
        setDocNumber("");
        setChecked(false);

        openNotification({
          titulo: "Hecho",
          descripcion: "La firma se guardó correctamente",
          placement: "bottomRight",
        });
        window.location.reload();
      }
    } catch (err) {
      console.error("Error al guardar firma:", err);
      openNotification({
        titulo: "Error",
        descripcion: "No se pudo guardar la firma. Intente nuevamente.",
        placement: "bottomRight",
      });
    }
  };

  //===========================================================
  //                     END SAVE SIGNATURE
  //===========================================================

  return (
    // @ts-ignore
    <div>
      <Content className="main--formal-box">
        <Content className="">
          <Content className="">
            <Row className="row d-flex justify-content-center">
              <Col className="col-12">
                <Content className="stts--lf-form-head">
                  <Content className="heading--title"></Content>
                </Content>

                <Content className="mb-2 mt-2">
                  <Content className="eval_pro_containt_area evelpro_card">
                    <Typography>
                      <br />
                      <hr />
                      <Paragraph>
                        <Content className="evalpro_containt_text">
                          <h4 className="title-text">
                            Aceptación de designación como jurado de la
                            convocatoria de fomento y estímulos
                          </h4>
                          <p className="containt-text">
                            Mediante esta comunicación dejo constancia expresa
                            que acepto la designación como jurado de la
                            Convocatoria de Fomento y Estímulos para el Arte y
                            la Cultura de Medellín, y en consecuencia manifiesto
                            que conozco las condiciones generales de
                            participación y mis obligaciones como jurado.
                          </p>

                          <h5 className="evalpro_list_Heading">
                            Además me comprometo a:{" "}
                          </h5>

                          <ol
                            className="evalpro_listting"
                            style={{ marginLeft: "50px" }}
                          >
                            <li>
                              <p>
                                Leer detenidamente los lineamientos generales y
                                específicos de participación de la Convocatoria
                                de Fomento y Estímulos, estos serán
                                suministrados por la Secretaría de Cultura
                                Ciudadana.{" "}
                              </p>
                            </li>

                            <li>
                              <p>
                                Declararme impedido para evaluar proyectos de
                                familiares o amigos. En caso de que más de la
                                mitad de jurados se declaren impedidos, la
                                Secretaría de Cultura Ciudadana designará
                                mediante acto administrativo jurados ad hoc para
                                evaluar las propuestas a las que haya lugar.{" "}
                              </p>
                            </li>

                            <li>
                              <p>
                                Analizar, evaluar y valorar técnicamente cada
                                una de las propuestas asignadas, con base en los
                                criterios establecidos para cada convocatoria y
                                modalidad, previo al proceso de deliberación
                                conjunta con los otros jurados.{" "}
                              </p>
                            </li>

                            <li>
                              <p>
                                Diligenciar y firmar por cada propuesta asignada
                                el formato de planilla de evaluación de acuerdo
                                a las especificaciones de la Secretaría de
                                Cultura Ciudadana.{" "}
                              </p>
                            </li>

                            <li>
                              <p>
                                Entregar los formatos de evaluación finalizados
                                el día de la deliberación conjunta con los otros
                                jurados. Estos deberán estar bien diligenciados
                                en su totalidad y bajo aprobación de la
                                consultoría.{" "}
                              </p>
                            </li>
                            <li>
                              <p>
                                Participar en la deliberación conjunta con los
                                otros jurados en la fecha y hora indicada por la
                                Secretaría de Cultura Ciudadana.{" "}
                              </p>
                            </li>
                            <li>
                              <p>
                                Observar total imparcialidad, objetividad y
                                actuar con plena autonomía.{" "}
                              </p>
                            </li>
                            <li>
                              <p>
                                {" "}
                                Abstenerme de hacer uso de la información a que
                                se accede para cualquier objetivo diferente de
                                la evaluación, respetando siempre los derechos
                                de autor del participante.{" "}
                              </p>
                            </li>
                            <li>
                              <p>
                                {" "}
                                Sustentar y firmar el acta de veredicto de
                                ganadores de las convocatorias que evalúe.{" "}
                              </p>
                            </li>
                            <li>
                              <p>
                                Retornar a la Secretaría de Cultura Ciudadana
                                todo el material evaluado para ser devuelto a
                                los participantes. (En caso de que se envíe
                                material físico).{" "}
                              </p>
                            </li>
                            <li>
                              <p>
                                Entregar los documentos que les sean requeridos
                                para el reconocimiento y remuneración del
                                servicio en los tiempos establecidos.{" "}
                              </p>
                            </li>
                            <li>
                              <p>
                                Informar en los tres primeros días posteriores a
                                la recepción de los documentos si algún archivo
                                no abre adecuadamente o no permite su
                                visualización.{" "}
                              </p>
                            </li>
                            <li>
                              <p>
                                Declaro que no tengo procesos en curso por la
                                comisión de delitos sexuales cometidos contra
                                menores de 18 años, de conformidad con lo
                                establecido en la Ley 1918 de 2018.{" "}
                              </p>
                            </li>
                          </ol>

                          <Content style={{ padding: "0.5rem 3rem" }}>
                            <p className="evalpro--btm-text-data">
                              Firmo en constancia de aceptar lo anteriormente
                              estipulado; de igual forma certifico que no hago
                              parte de ningún proyecto presentado a la
                              Convocatoria de Fomento y Estímulos para el Arte y
                              la Cultura de Medellín en la presente etapa y
                              línea, y que actualmente no soy servidor público
                              de ninguna entidad estatal de Colombia.{" "}
                            </p>

                            <h5 className="eval__frm_text">
                              A continuación adjunte la imagen de su firma en
                              formato png y su número de documento.
                            </h5>

                            <Content className="evalpro--form">
                              <Form>
                                <Content>
                                  <span
                                    className="asgevl_form_lable"
                                    style={{ marginTop: "15px" }}
                                  >
                                    Firma
                                  </span>
                                  <Form.Item
                                    className="no-margin"
                                    name="path_anexo"
                                    style={{
                                      display: "flex",
                                      alignItems: "end",
                                    }}
                                    rules={[{ required: true, message: "" }]}
                                  >
                                    <Input.Group
                                      compact
                                      style={{
                                        display: "block",
                                        alignItems: "end",
                                      }}
                                    >
                                      <img
                                        src={fileName}
                                        style={{
                                          maxWidth: "100%",
                                          width: "250px",
                                          height: "auto",
                                          maxHeight: "160px",
                                          objectFit: "contain",
                                          border: "1px solid #e0e0e0",
                                          borderRadius: "6px",
                                          padding: "6px",
                                          background: "#fff",
                                        }}
              alt=""
              />
                                      <br />
                                      <hr />
                                      <span
                                        className="asgevl_form_lable"
                                        style={{ marginTop: "15px" }}
                                      >
                                        Actualizar firma:
                                      </span>
                                      <br />
                                      <input
                                        ref={fileInputRef}
                                        type="file"
                                        style={{ maxWidth: "100%" }}
                                        onChange={(e: any) => {
                                          selectFile(e);
                                        }}
                                      />
                                    </Input.Group>
                                  </Form.Item>
                                </Content>

                                <Content className="mt-1">
                                  <Row style={{ marginTop: "15px" }}>
                                    <Col span={18} style={{ padding: "3px" }}>
                                      <span className="asgevl_form_lable">
                                        Número de documento*
                                      </span>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col
                                      span={matchScreenSize > 768 ? 18 : 16}
                                      // style={{ padding: "3px" }}
                                    >
                                      {/* <span
                                          style={{ marginTop: "1.5rem" }}
                                        ></span> */}
                                      <Input
                                        placeholder="No."
                                        style={{
                                          // height: "40px",
                                          borderRadius: "6px",
                                        }}
                                        onChange={(e) =>
                                          setDocNumber(e.target.value)
                                        }
                                        value={docNumber}
                                      />
                                    </Col>
                                  </Row>
                                </Content>
                              </Form>
                            </Content>
                          </Content>
                        </Content>

                        <Content>
                          <Row className="row mt-2">
                            <Col
                              className="col-12 form--btm-btn-box"
                              style={{
                                marginRight: "0.5rem",
                                marginTop: "15px",
                              }}
                            >
                              <Button
                                onClick={handleSubmit}
                                className="form_bg_btn"
                                type="primary"
                              >
                                Actualizar firma
                              </Button>
                            </Col>
                          </Row>
                        </Content>
                      </Paragraph>
                    </Typography>
                  </Content>
                </Content>
              </Col>
            </Row>
          </Content>
        </Content>
      </Content>
    </div>
  );
}
